module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }